import { useContext, useEffect, useState } from 'react';
import { AiOutlineHome } from "react-icons/ai";
import { IoCartOutline, IoReceiptOutline } from 'react-icons/io5';
import { useLocation } from 'react-router-dom';
import CompanyContext from '../../contexts/companyContext';
import { useAppRouter } from '../../hooks/useAppRouter';
import useStorage from '../../hooks/useStorage';
import './css/bottomMenu.css';

export default function BottomNavigator() {
  const storage = useStorage();
  const navigate = useAppRouter();
  const cLocation = useLocation();
  const screenArr = cLocation.pathname.split('/');
  const screen = screenArr[screenArr.length - 1];
  const { companyData } = useContext(CompanyContext);
  const [countProducts, setCountProducts] = useState(0);



  useEffect(() => {
    findProducts();

    window.addEventListener('storage', findProducts);

    return () => {
      window.removeEventListener('storage', findProducts);
    };
  }, []);


  async function findProducts() {
    let res = await storage.get('CART');

    if (res && res.companyId !== companyData.id) {
      storage.clear('CART');
    }

    let soma = 0;

    if (res) {
      soma = res.products.reduce((soma, item) => soma + item.amount, 0);
    }

    if(soma !== countProducts){
      setCountProducts(soma);
    }
  }


  useEffect(() => {
    if(screen == 'menu') setTimeout(findProducts, 1000)
  }, [countProducts, screen]);


  return (
    <section className="bottom-menu" style={{ backgroundColor: companyData.background_color }}>
      <button className="iconBtn" onClick={() => navigate('menu')} style={{opacity: screen != 'menu' ? 0.6 : 1 }}>
        <AiOutlineHome color={companyData.text_color} size={25} />
        <p className={'text-bottom-navigator'} style={{color: companyData.text_color}}>Início</p>
      </button>

      {/* BLOQUEIO-DE-PEDIDOS-DELIVERY-NO-SMARTMENU.spec.md: sem pedidos, só Início e Conta (acompanhar pedidos já feitos) */}
      {!companyData.orders_blocked && (
        <button className="iconBtn" onClick={() => navigate('cart')} style={{opacity: screen != 'cart' ? 0.6 : 1 }}>
          <IoCartOutline color={companyData.text_color} size={30}/>
          {countProducts > 0 && (
            <p className="count-products" style={{ backgroundColor: companyData.text_color, color: companyData.background_color }}>
              {countProducts}
            </p>
          )}
          <p className={'text-bottom-navigator'} style={{color: companyData.text_color}}>Pedido</p>
        </button>
      )}

      <button className="iconBtn" onClick={() => navigate('account')} style={{opacity: screen != 'account' ? 0.6 : 1 }}>
        <IoReceiptOutline color={companyData.text_color} size={25} />
        <p className={'text-bottom-navigator'} style={{color: companyData.text_color}}>Conta</p>

      </button>
    </section>
  );
}
